<router-outlet />

@if (loading$ | async) {
  <div class="app-page-loading-overlay">
    <app-loading-component></app-loading-component>
  </div>
}
